'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var _ = require('lodash');  /* jshint ignore:line */
var RegulatoryComplianceList = require(
    './v2/regulatoryCompliance').RegulatoryComplianceList;
var Version = require('../../base/Version');  /* jshint ignore:line */


/* jshint ignore:start */
/**
 * Initialize the V2 version of Numbers
 *
 * @constructor Twilio.Numbers.V2
 *
 * @property {Twilio.Numbers.V2.RegulatoryComplianceList} regulatoryCompliance -
 *          regulatoryCompliance resource
 *
 * @param {Twilio.Numbers} domain - The twilio domain
 */
/* jshint ignore:end */
function V2(domain) {
  Version.prototype.constructor.call(this, domain, 'v2');

  // Resources
  this._regulatoryCompliance = undefined;
}

_.extend(V2.prototype, Version.prototype);
V2.prototype.constructor = V2;

Object.defineProperty(V2.prototype,
  'regulatoryCompliance', {
    get: function() {
      this._regulatoryCompliance = this._regulatoryCompliance || new RegulatoryComplianceList(this);
      return this._regulatoryCompliance;
    }
});

module.exports = V2;
